export default "__VITE_ASSET__7f740642__"